import { render } from "./CrudUser.vue?vue&type=template&id=66567644"
import script from "./CrudUser.vue?vue&type=script&lang=js"
export * from "./CrudUser.vue?vue&type=script&lang=js"

import "./CrudUser.vue?vue&type=style&index=0&id=66567644&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__